
import Button from '../../../components/base/Button';

export default function EducationHubSection() {
  const educationPrograms = [
    {
      title: "Clinical Pharmacy Practice",
      duration: "40 Hours",
      level: "Intermediate",
      description: "Advanced clinical skills for pharmacy professionals working in collaborative care environments.",
      image: "https://public.readdy.ai/ai/img_res/797b849220f0238301ed2dc0c37c09e9.jpg"
    },
    {
      title: "Veterinary Pharmacology",
      duration: "35 Hours", 
      level: "Advanced",
      description: "Specialized training in veterinary drug therapy and animal health management.",
      image: "https://readdy.ai/api/search-image?query=Veterinarian%20examining%20animal%20in%20modern%20clinic%2C%20professional%20veterinary%20care%2C%20animal%20health%20consultation%2C%20vet%20with%20medical%20equipment%20treating%20pets%2C%20veterinary%20medicine%20practice&width=400&height=250&seq=edu3&orientation=landscape"
    },
    {
      title: "One Health Approach",
      duration: "25 Hours",
      level: "Beginner",
      description: "Understanding the interconnection between human, animal, and environmental health.",
      image: "https://readdy.ai/api/search-image?query=Healthcare%20professionals%20collaborating%20on%20One%20Health%20initiatives%2C%20interdisciplinary%20team%20meeting%2C%20human%20and%20animal%20health%20coordination%2C%20collaborative%20healthcare%20environment&width=400&height=250&seq=edu4&orientation=landscape"
    },
    {
      title: "Digital Health Integration",
      duration: "30 Hours",
      level: "Intermediate",
      description: "Leveraging technology for improved healthcare delivery and patient outcomes.",
      image: "https://readdy.ai/api/search-image?query=Healthcare%20professionals%20using%20digital%20technology%2C%20medical%20tablets%20and%20computers%2C%20modern%20healthcare%20technology%2C%20digital%20health%20solutions%20in%20clinical%20setting&width=400&height=250&seq=edu5&orientation=landscape"
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <i className="ri-graduation-cap-line text-2xl text-blue-600"></i>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Education Hub
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Comprehensive learning resources designed to advance your professional knowledge and skills in both pharmacy and veterinary care.
          </p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
          {educationPrograms.map((program, index) => (
            <div key={index} className="bg-gray-50 rounded-xl overflow-hidden hover:shadow-lg transition-shadow">
              <img
                src={program.image}
                alt={program.title}
                className="w-full h-48 object-cover object-top"
              />
              <div className="p-6">
                <div className="flex items-center justify-between mb-4">
                  <span className={`px-3 py-1 rounded-full text-sm font-medium ${
                    program.level === 'Beginner' ? 'bg-green-100 text-green-800' :
                    program.level === 'Intermediate' ? 'bg-yellow-100 text-yellow-800' :
                    'bg-red-100 text-red-800'
                  }`}>
                    {program.level}
                  </span>
                  <span className="text-sm text-gray-500">{program.duration}</span>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {program.title}
                </h3>
                <p className="text-gray-600 mb-4">
                  {program.description}
                </p>
                <Button variant="outline" size="sm">
                  Enroll Now
                </Button>
              </div>
            </div>
          ))}
        </div>
        
        <div className="bg-blue-50 rounded-2xl p-8 text-center">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">
            Continuing Education Credits
          </h3>
          <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
            All our programs are accredited and provide continuing education credits for both pharmacy and veterinary professionals.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button size="lg">
              View All Courses
            </Button>
            <Button variant="outline" size="lg">
              Credit Information
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
